export default class WebError implements Error {
  name: string = 'WebError';
  message: string = 'Unsuccessful web request.';
}
